import React from "react";
import PackageButton from "./packageButton";
import { Button, Heading } from "react-bulma-components";

function PackagePicker(props) {

  const minitiers = props.packages.filter((tier) => tier !== 'Local Plus' && tier !== 'Complete Lite' && tier !== "Complete" && tier !== "Advanced" && tier !== "Ultra")

  const PackageButtons = minitiers.map((i) => (
    <PackageButton 
        package={i} 
        key={i}
        onclick={props.onClick}
        currentTier={props.currentTier}
    ></PackageButton>
  ));

  return (
    <>
      <Heading size="6" renderAs="h4">Package</Heading>
      <Heading subtitle size="6" renderAs="p">Click below to filter by package. Clear filter to see all channels.</Heading>
      <Heading size="5" renderAs="h3">Base Packages</Heading>
      <Button.Group>
      <PackageButton 
        package={"Local Plus"} 
        key={"Local Plus"}
        onclick={props.onClick}
        currentTier={props.currentTier}
    ></PackageButton>
    <PackageButton 
        package={"Complete Lite"} 
        key={"Complete Lite"}
        onclick={props.onClick}
        currentTier={props.currentTier}
    ></PackageButton>
    <PackageButton 
        package={"Complete"} 
        key={"Complete"}
        onclick={props.onClick}
        currentTier={props.currentTier}
    ></PackageButton>
    </Button.Group>
      <Heading size="5" renderAs="h3">Add-on Packages</Heading>
      <Heading subtitle size="6" renderAs="p">Lite add-ons require complete lite. Sports &amp; Information, Sports Plus, Movies Plus, Family and Lifestyle &amp; Music require Complete. </Heading>
      <Button.Group>
        {PackageButtons}
      </Button.Group>
      <Button onClick={props.clear}>Clear Package Selection</Button>
    </>
  );
}

export default PackagePicker;

